import { render, staticRenderFns } from "./OtherSection.vue?vue&type=template&id=247cfbf0&scoped=true&"
import script from "./OtherSection.vue?vue&type=script&lang=js&"
export * from "./OtherSection.vue?vue&type=script&lang=js&"
import style0 from "./OtherSection.vue?vue&type=style&index=0&id=247cfbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cfbf0",
  null
  
)

export default component.exports